export default "__VITE_ASSET__ThrZt3Jp__"